import axios from 'axios';

let API_URL

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  API_URL = "http://localhost:8080/api/auth/"
} else if (process.env.NODE_ENV === 'test'){
  API_URL = "https://staging.api.segurosviagem.pt/api/auth/"
}else {
  API_URL = "https://api.segurosviagem.pt/api/auth/"
}

class AuthService {
  login(user) {
    return axios
      .post(API_URL + 'signin', {
        username: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
          document.location.reload(true);
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }
}

export default new AuthService();